import React, { Fragment } from 'react';

// A function that takes a list of items, and returns them in a comma separated format.
export function commaSeparateList(items: Array<string>): React.ReactNode {
  let list;
  if (items.length === 1) {
    return <strong>{items[0]}</strong>;

  } else if (items.length === 2) {
    return (
      <Fragment>
        <strong>{items[0]}</strong>, and{' '}
        <strong>{items[1]}</strong>
      </Fragment>
    );

  } else if (items.length === 3) {
    return (
      <Fragment>
        <strong>{items[0]}</strong>,{' '}
        <strong>{items[1]}</strong>, and{' '}
        <strong>{items[2]}</strong>
      </Fragment>
    );

  } else {
    return (
      <Fragment>
        <strong>{items.slice(0, 3).join(', ')}</strong> and{' '}
        {items.length - 3} more
      </Fragment>
    );
  }
}
